import React from 'react'
import styled from '@emotion/styled'

import { ProfileLinkItem } from '~/constants/profile'

interface Props extends ProfileLinkItem {
  hasName?: boolean
}

const LinkItem: React.FC<Props> = ({ name, url, icon, hasName = true }) => {
  return (
    <Wrapper href={url} target="_blank">
      {icon}
      {hasName && name}
    </Wrapper>
  )
}

const Wrapper = styled.a`
  margin-top: 2px;
  display: flex;
  align-items: center;
  column-gap: 7px;

  ${({ theme: { typography } }) => typography.tag1}
  color: ${({ theme: { colors } }) => colors.deepText};
  letter-spacing: 0.3px;

  svg {
    color: gray;
  }
`

export default LinkItem
